import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../Global/Buttons/Button';
import ContentList from '../Global/Lists/ContentList';
import VerticalTextLockup from '../Global/Typography/VerticalTextLockup';
import NoResultsMessage from '../Global/Messages/NoResultsMessage';

const DiagramImageList = ({ diagrams, onDiagramClick, activeItem, loading }) => {
  const handleDiagramClick = (e, diagram) => {
    e.preventDefault();
    onDiagramClick(diagram);
  };

  if (diagrams.length > 0) {
    return (
      <ContentList>
        {diagrams.map((diagram) => {
          const listClass = classNames({
            active: activeItem && activeItem.id === diagram.id,
          });

          return (
            <li key={diagram.id} className={listClass}>
              <Button onClick={e => handleDiagramClick(e, diagram)} faux>
                <div className="thumbnail-container">
                  <img src={diagram.src} alt={diagram.alt} />
                </div>
                <VerticalTextLockup
                  title={<h3>{diagram.title}</h3>}
                  subtitle={<span>Edited on {diagram.date_modified_readable}</span>}
                />
              </Button>
            </li>
          );
        })}
      </ContentList>
    );
  }

  return (
    <NoResultsMessage
      title="You don't currently have any diagrams"
      text="Once you've created a diagram you can select it from here to add it to your practice."
      loading={loading}
    />
  );
};

DiagramImageList.propTypes = {
  diagrams: PropTypes.array,
  onDiagramClick: PropTypes.func,
  activeItem: PropTypes.object,
  loading: PropTypes.bool,
};

export default DiagramImageList;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/DiagramImageList.js